import { getApiClient } from "../apiClient";
import { WORKOUT_ENDPOINTS } from "../endpoints";
import type {
  WorkoutPayload,
  WorkoutResponse,
  GetWorkoutsParams,
  GetWorkoutsResponse,
  GetWorkoutResponse,
  GetProgramsParams,
  GetProgramsResponse,
  GetProgramResponse,
} from "../types/workout.types";
import { replacePathParams } from "../endpoints";

export const workoutService = {
  createWorkout: (body: WorkoutPayload): Promise<WorkoutResponse> => {
    return getApiClient().post(WORKOUT_ENDPOINTS.createWorkout, body);
  },

  getWorkouts: (params?: GetWorkoutsParams): Promise<GetWorkoutsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append("page", String(params.page));
    if (params?.limit) queryParams.append("limit", String(params.limit));
    if (params?.offset) queryParams.append("offset", String(params.offset));
    if (params?.search) queryParams.append("search", params.search);

    const url = queryParams.toString()
      ? `${WORKOUT_ENDPOINTS.getWorkouts}?${queryParams.toString()}`
      : WORKOUT_ENDPOINTS.getWorkouts;

    return getApiClient().get(url);
  },

  getWorkout: (id: string): Promise<GetWorkoutResponse> => {
    const url = replacePathParams(WORKOUT_ENDPOINTS.getWorkout, { id });
    return getApiClient().get(url);
  },

  deleteWorkout: (id: string): Promise<any> => {
    const url = replacePathParams(WORKOUT_ENDPOINTS.deleteWorkout, { id });
    return getApiClient().delete(url);
  },

  updateWorkout: (
    id: string,
    body: WorkoutPayload
  ): Promise<WorkoutResponse> => {
    const url = replacePathParams(WORKOUT_ENDPOINTS.getWorkout, { id });
    return getApiClient().put(url, body);
  },

  getMuxToken: (playbackId: string): Promise<any> => {
    const queryParams = new URLSearchParams({ playbackId });
    return getApiClient().get(
      `${WORKOUT_ENDPOINTS.getMuxToken}?${queryParams.toString()}`
    );
  },

  addProgram: (body: any): Promise<any> => {
    return getApiClient().post(WORKOUT_ENDPOINTS.addProgram, body);
  },

  getPrograms: (params?: GetProgramsParams): Promise<GetProgramsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append("page", String(params.page));
    if (params?.limit) queryParams.append("limit", String(params.limit));
    if (params?.offset) queryParams.append("offset", String(params.offset));
    if (params?.search) queryParams.append("search", params.search);

    const url = queryParams.toString()
      ? `${WORKOUT_ENDPOINTS.getPrograms}?${queryParams.toString()}`
      : WORKOUT_ENDPOINTS.getPrograms;

    return getApiClient().get(url);
  },

  getProgram: (id: string): Promise<GetProgramResponse> => {
    const url = replacePathParams(WORKOUT_ENDPOINTS.getProgram, { id });
    return getApiClient().get(url);
  },

  getWeeklyPrograms: (id: string): Promise<any> => {
    const baseUrl = replacePathParams(WORKOUT_ENDPOINTS.getWeeklyPrograms, { id });
    const queryParams = new URLSearchParams({
      page: "1",
      limit: "100",
      offset: "0",
    });
    const url = `${baseUrl}?${queryParams.toString()}`;
    return getApiClient().get(url);
  },

  updateProgram: (id: string, body: any): Promise<any> => {
    const url = replacePathParams(WORKOUT_ENDPOINTS.updateProgram, { id });
    return getApiClient().put(url, body);
  },

  deleteProgram: (id: string): Promise<any> => {
    const url = replacePathParams(WORKOUT_ENDPOINTS.deleteProgram, { id });
    return getApiClient().delete(url);
  },

  updateWeeklyPrograms: (id: string, body: any): Promise<any> => {
    const url = replacePathParams(WORKOUT_ENDPOINTS.updateWeeklyPrograms, { id });
    return getApiClient().put(url, body);
  },

  deleteWeeklyProgram: (id: string): Promise<any> => {
    const url = replacePathParams(WORKOUT_ENDPOINTS.deleteWeeklyProgram, { id });
    return getApiClient().delete(url);
  },
  getRefWorkouts: (id: string): Promise<any> => {
    const url = replacePathParams(WORKOUT_ENDPOINTS.refWorkouts, { id });
    return getApiClient().get(url);
  },
};
